import React from 'react';
import Navigation from './Navigation';
import './home.css';

const ContactIllustration = () => (
  <svg viewBox="0 0 480 360" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 460, borderRadius: 12 }}>
    <rect width="480" height="360" rx="14" fill="#e8f4f0"/>
    {/* envelope body */}
    <rect x="60" y="100" width="360" height="220" rx="14" fill="#fff" stroke="#d0dce8" strokeWidth="2"/>
    {/* envelope flap lines */}
    <line x1="60" y1="100" x2="240" y2="200" stroke="#b0cce0" strokeWidth="2"/>
    <line x1="420" y1="100" x2="240" y2="200" stroke="#b0cce0" strokeWidth="2"/>
    {/* shield icon */}
    <circle cx="240" cy="228" r="44" fill="#e0f2ec"/>
    <path d="M240 200l-22 10v18c0 14 9.5 26 22 30 12.5-4 22-16 22-30v-18l-22-10z" fill="#4fc3a1"/>
    <path d="M232 228l6 6 12-12" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    {/* text lines */}
    <rect x="120" y="296" width="240" height="10" rx="4" fill="#e2eaf2"/>
    <rect x="160" y="314" width="160" height="8" rx="4" fill="#e2eaf2"/>
  </svg>
);

function Contact() {
  return (
    <div>
      <Navigation />

      <div className="main-content">
        <div className="text-content">
          <div className="contact-section">
            <span className="hero-badge">Get in Touch</span>
            <h2>Contact Us</h2>
            <p>
              Have questions about ComplianceGenie? Want to schedule a demo or learn how we can help
              your organization stay audit-ready? We're here to help.
            </p>
            <div className="contact-details">
              <p>📧 Email: <a href="mailto:info@cloudservesystems.com">info@cloudservesystems.com</a></p>
              <p>📞 Phone: <a href="tel:+917600002540">+91 760 000 2540</a></p>
              <p>📍 G-202, Maple Tree, Near Surdhara Circle, Thaltej, Ahmedabad – 380052, India</p>
            </div>
          </div>
        </div>
        <div className="image-content">
          <ContactIllustration />
        </div>
      </div>

      {/* ── CTA strip ── */}
      <div className="cta-section">
        <h1>Want to see ComplianceGenie in action?</h1>
        <p>
          Book a 30-minute demo with our team and see how we can help automate your compliance workflows
          across ISO 27001, SOC 2, GDPR, and more.
        </p>
        <div className="hero-actions" style={{ justifyContent: 'center' }}>
          <a href="mailto:info@cloudservesystems.com" className="btn-primary">Book a Demo</a>
        </div>
      </div>

      {/* ── Footer ── */}
      <section className="footer">
        <h4>Cloudserve Systems Pvt. Ltd.</h4>
        <p>G-202, Maple Tree, Near Surdhara Circle, Thaltej, Ahmedabad – 380052, India</p>
        <div className="icons">
          +91 760 000 2540
          <div className="Policy">
            <a href="/privacy.html" target="_blank" rel="noreferrer"><b>Privacy Policy</b></a>
            <a href="/term_conditions.html" target="_blank" rel="noreferrer"><b>Terms of Use</b></a>
          </div>
        </div>
        <p>Copyright © 2017 Cloudserve Systems Pvt. Ltd. All rights reserved.</p>
      </section>
    </div>
  );
}

export default Contact;
